/*
 * DAC page loader: a thin line that runs across the top of the screen while something loads, like the one on google.
 * It shows for the loads the theme already announces (theme:loading:start / theme:loading:end: filters, sorting, colour change,
 * cart) and for normal page changes (clicking a link to another page, submitting a form), which the theme did not show anything for.
 * The look is in theme.css (.dac-page-loader) and the colour is the theme setting "Loading line colour".
 */
(function () {
  if (window.dacPageLoader) {
    return;
  }

  var bar = document.createElement('div');
  bar.className = 'dac-page-loader';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var pending = 0;
  var progress = 0;
  var showTimer = null;
  var trickleTimer = null;
  var hideTimer = null;
  var safetyTimer = null;

  function render() {
    bar.style.transform = 'scaleX(' + progress + ')';
  }

  function show() {
    clearTimeout(hideTimer);
    bar.classList.add('is-active');
    progress = 0.12;
    render();

    // slows down the closer it gets to the end, so it keeps moving but never reaches it until the load is done
    trickleTimer = setInterval(function () {
      progress += (0.95 - progress) * 0.07;
      render();
    }, 180);
  }

  function reset() {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    clearTimeout(safetyTimer);
    clearInterval(trickleTimer);
    pending = 0;
    progress = 0;
    bar.classList.add('is-resetting');
    bar.classList.remove('is-active');
    bar.style.transform = 'scaleX(0)';
    void bar.offsetWidth;
    bar.classList.remove('is-resetting');
  }

  function start() {
    pending += 1;

    if (pending > 1) {
      return;
    }

    clearTimeout(hideTimer);

    // a load that finishes straight away (cached) does not flash the line
    showTimer = setTimeout(show, 80);
  }

  function end() {
    pending = Math.max(0, pending - 1);

    if (pending > 0) {
      return;
    }

    clearTimeout(showTimer);
    clearInterval(trickleTimer);

    if (!bar.classList.contains('is-active')) {
      return;
    }

    progress = 1;
    render();

    hideTimer = setTimeout(function () {
      bar.classList.remove('is-active');
      hideTimer = setTimeout(reset, 350);
    }, 250);
  }

  document.addEventListener('theme:loading:start', start);
  document.addEventListener('theme:loading:end', end);

  /* a page change: nothing ends it, the page just goes away. Safety timer in case the browser never leaves (download, cancelled). */
  function startNavigation() {
    start();
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(end, 15000);
  }

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var link = event.target.closest ? event.target.closest('a[href]') : null;

    if (!link || link.hasAttribute('download') || link.hasAttribute('data-no-loader')) {
      return;
    }

    if (link.target && link.target !== '_self') {
      return;
    }

    if (!/^https?:$/.test(link.protocol) || link.origin !== window.location.origin) {
      return;
    }

    // same page, only the hash changes
    if (link.pathname === window.location.pathname && link.search === window.location.search && link.hash) {
      return;
    }

    // wait for the other click handlers: if one of them took over the click (drawers, filters, ...) there is no page change
    setTimeout(function () {
      if (!event.defaultPrevented) {
        startNavigation();
      }
    }, 0);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || form.hasAttribute('data-no-loader') || (form.target && form.target !== '_self') || form.method === 'dialog') {
      return;
    }

    setTimeout(function () {
      if (!event.defaultPrevented) {
        startNavigation();
      }
    }, 0);
  });

  // coming back with the back button can restore the page with the line still running
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      reset();
    }
  });

  window.dacPageLoader = { start: start, end: end };
})();
